var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYieldToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577_36947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6873 15.6874H16.3123M15.6873 16.3124H16.3123M17.6667 7.83328C17.1282 7.72397 16.5708 7.66659 16 7.66659C11.3976 7.66659 7.66669 11.3975 7.66669 15.9999C7.66669 20.6023 11.3976 24.3333 16 24.3333C20.6024 24.3333 24.3334 20.6023 24.3334 15.9999C24.3334 14.4821 23.9275 13.059 23.2185 11.8333M16.8334 15.9999C16.8334 16.4602 16.4603 16.8333 16 16.8333C15.5398 16.8333 15.1667 16.4602 15.1667 15.9999C15.1667 15.5397 15.5398 15.1666 16 15.1666C16.4603 15.1666 16.8334 15.5397 16.8334 15.9999ZM20.1667 15.9999C20.1667 18.3011 18.3012 20.1666 16 20.1666C13.6988 20.1666 11.8334 18.3011 11.8334 15.9999C11.8334 13.6987 13.6988 11.8333 16 11.8333C18.3012 11.8333 20.1667 13.6987 20.1667 15.9999ZM21 8.49992C21 9.42039 20.2538 10.1666 19.3334 10.1666C18.4129 10.1666 17.6667 9.42039 17.6667 8.49992C17.6667 7.57944 18.4129 6.83325 19.3334 6.83325C20.2538 6.83325 21 7.57944 21 8.49992Z",
    stroke: "#00AC69",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577_36947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYieldToday);
export default __webpack_public_path__ + "static/media/yield-today.37c0d5c418892e986458073ba8cbe09c.svg";
export { ForwardRef as ReactComponent };